export default __webpack_public_path__ + "static/contact-form-bg-0240c8c4193a798a884cfd995202392b.jpg";